<template>
  <Modal
    :id="id"
    :modalTitle="modalTitle"
    :class="classes"
    :showFooter="showFooter"
    :onClose="onClose"
  >
    <div v-if="tabSelected === 1">
      <table class="table" v-if="products.length > 0">
        <thead>
          <tr>
            <th scope="col" class="align-middle">Nombre del producto</th>
            <th scope="col" class="align-middle">Cantidad</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(product, index) in products"
            v-bind:key="product.partCode"
          >
            <td>{{ product.name }}</td>
            <td>
              <NumberInput
                v-if="parseInt(product.quantity) > 0"
                @changeProductBusiness="
                  handleProductBusinessChange($event, product.partCode)
                "
                @deleteProductBusiness="deleteProductBusiness(product.partCode)"
                :maxValue="product.stock"
                :amount="parseInt(product.quantity)"
                :index="index"
              >
              </NumberInput>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>

      <button
        class="btn btn-primary generalTertiaryButton float-right"
        @click="tabSelected = 2"
        v-if="products.length > 0"
      >
        Continuar
      </button>
      <button
        @click="onClose"
        class="btn btn-primary generalPrimaryButton float-left"
        v-if="products.length > 0"
      >
        Cerrar
      </button>
    </div>

    <div v-if="tabSelected === 2">
      <table class="table" v-if="products.length > 0">
        <thead>
          <tr>
            <th scope="col" class="align-middle">Nombre del producto</th>
            <th
              scope="col"
              class="align-middle"
              @click="secureSelected = 'ESSENTIAL'"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input checkdisabled"
                  disabled
                  :checked="secureSelected === 'ESSENTIAL'"
                  id="ESSENTIAL"
                />
                <label class="custom-control-label labelCheck" for="ESSENTIAL"
                  >Basic
                </label>
              </div>
            </th>

            <th
              scope="col"
              class="align-middle"
              @click="secureSelected = 'TOTAL'"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input checkdisabled"
                  disabled
                  :checked="secureSelected === 'TOTAL'"
                  id="TOTAL"
                />
                <label class="custom-control-label labelCheck" for="TOTAL"
                  >Premium
                </label>
              </div>
            </th>

            <th
              scope="col"
              class="align-middle"
              @click="secureSelected = 'MAINTENANCE'"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input checkdisabled"
                  disabled
                  :checked="secureSelected === 'MAINTENANCE'"
                  id="MAINTENANCE"
                />
                <label class="custom-control-label labelCheck" for="MAINTENANCE"
                  >Rentik Care
                </label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" v-bind:key="product.partCode">
            <td>{{ product.name }}</td>
            <td>{{ getPolicyPrice(product, 'ESSENTIAL') }}</td>
            <td>{{ getPolicyPrice(product, 'TOTAL') }}</td>
            <td>{{ getPolicyPrice(product, 'MAINTENANCE') }}</td>
          </tr>
        </tbody>
      </table>

      <button
        class="btn btn-primary generalTertiaryButton float-right"
        data-dismiss="modal"
        @click="continuar"
        v-if="products.length > 0"
      >
        Continuar
      </button>
      <button
        @click="onClose"
        class="btn btn-primary generalPrimaryButton float-left"
        v-if="products.length > 0"
      >
        Cerrar
      </button>
    </div>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
</template>

<script>
import Modal from "../../../Shared/Modal.vue"
import NumberInput from "./templates/NumberInput.vue"

export default {
  name: "SelectedProducts",
  props: ["id", "modalTitle", "class", "showFooter", "show", "tab"],
  components: {
    Modal,
    NumberInput
  },
  data() {
    return {
      tabSelected: this.tab,
      secureSelected: "ESSENTIAL",
      classes: this.class,
      products: this.$store.state.newContractData.product
    }
  },
  created() {
    this.$store.subscribe((mutation, payload) => {
      if (mutation.type == "setNewContractDataProduct") {
        this.products = payload.newContractData.product
      }
    })
  },
  methods: {
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click()
      this.$emit("closeModal", "")
    },
    continuar() {
      console.log(
        this.products[0].policyOptions.filter(
          (producto) => producto.policyType === this.secureSelected
        ),
        "console"
      )

      let productsTemp = []

      this.products.map((product) => {
        let policy = product.policyOptions.filter(
          (producto) => producto.policyType === this.secureSelected
        )[0]
        product.policy = policy
        productsTemp.push(product)
      })

      this.$store.commit("setNewContractDataProduct", productsTemp)
      this.$router.push({ name: "newContractStep2" })
    },
    handleProductBusinessChange(result, partCode) {
      const indexToUpdate = this.products.findIndex(
        (product) => product.partCode === partCode
      )
      let productsSelected = this.products

      if (indexToUpdate !== -1) {
        // Si se encuentra el partCode, actualiza el valor de quantity con result
        productsSelected[indexToUpdate].quantity = result
        console.log(productsSelected, this.products, result)
        this.$store.commit("setNewContractDataProduct", productsSelected)
      }
    },
    deleteProductBusiness(partCode) {
      // retorna todos los productos que tengan un partCode distinto
      const productsSelected = this.products.filter(
        (producto) => producto.partCode !== partCode
      )
      this.$store.commit("setNewContractDataProduct", productsSelected)
    },
    getPolicyPrice(product, policyType) {
      const option = (product.policyOptions || []).find(
        (p) => p.policyType === policyType
      )
      return option ? `${option.monthlyGrossPolicy} €` : "-"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.checkdisabled[disabled] ~ .custom-control-label,
.checkdisabled:disabled ~ .custom-control-label {
  color: #000 !important;
  user-select: none;
  cursor: pointer;
}
.custom-control {
  min-height: auto !important;
}
</style>
